import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { setTranslateUrlFn } from '../services/navigation';
import withTranslateUrls from '../withTranslateUrls';
import { isMultilingual } from '../../languages';

const withNavigation = (WrappedComponent) => {
  const WithNavigation = (props) => {
    const { translateUrlsContext: { translateUrl, locale } } = props;

    if (isMultilingual) {
      useEffect(() => {
        const wrappedTranslateUrl = (url) => {
          try {
            const urlObj = new URL(url);
            urlObj.hostname = 'tilli.com';
            if (locale && !['fr', 'en'].includes(locale)) {
              urlObj.pathname = `/${locale}${urlObj.pathname}`;
            }
            return translateUrl(urlObj.toString());
          } catch (error) {
            console.warn('withNavigation: translateUrl: error', error);
            return translateUrl(url);
          }
        };

        setTranslateUrlFn(wrappedTranslateUrl);
      }, [translateUrl, locale]);
    }

    return <WrappedComponent {...props} />;
  };

  WithNavigation.propTypes = {
    translateUrlsContext: PropTypes.shape({
      translateUrl: PropTypes.func,
      locale: PropTypes.string,
    }),
  };

  WithNavigation.defaultProps = {
    translateUrlsContext: {
      translateUrl: () => {},
      locale: 'fr',
    },
  };

  return withTranslateUrls(WithNavigation);
};

export default withNavigation;
